export const VISITOR_STORAGE_KEY = 'rnf_visitor_id_v2';
export const VISITOR_STATS_NOTICE = '이용자수는 브라우저 기준 고유 방문자이며, V2 집계 적용 이후부터 계산됩니다. 프로모션별로 집계하며 기존 V1 수치와 합산하지 않습니다.';
export const STATISTICS_ORIGIN = 'https://newb.rentaltalk.kr';

export function normalizeVisitorId(value) {
  return typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
    ? value.toLowerCase() : null;
}

export function isLocalStatisticsHost(hostname) {
  return /^(localhost|127\.0\.0\.1|\[?::1\]?)$/i.test(hostname) || hostname.toLowerCase().endsWith('.localhost');
}

export function isStatisticsCrawler(userAgent) {
  return /(facebookexternalhit|twitterbot|slackbot|discordbot|googlebot|googlemessages|bingbot|yeti|naverbot|daum|baiduspider|kakaotalk-scrap|applebot)/i.test(userAgent)
    || userAgent === 'Mozilla/5.0 (X11; Ubuntu; Linux i686; rv:24.0) Gecko/20100101 Firefox/24.0';
}

export const isViewEvent = record => record.eventType !== 'visitorV2';

export const summarizeViewRecords = records => ({
  totalViews: records.filter(isViewEvent).length,
  uniqueVisitorsV2: new Set(records.map(record => record.visitorKeyV2).filter(Boolean)).size
});
